import { defineMessages } from 'react-intl';

import { pullRequestStatusMessages } from '../../../../../../../common/utils/pull-request-status';

const localMessages = defineMessages({
	resultLabel: {
		id: 'search-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'Search pull request label',
	},
	commentsLabel: {
		id: 'search-pull-request-result.comments-label',
		defaultMessage: '{count} {count, plural, one {comment} other {comments}}',
		description: 'Label for the PR comments expand section, showing the number of comments',
	},
});

export const messages = {
	...localMessages,
	...pullRequestStatusMessages,
};
